import React, { Component} from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import Rist from './Rist'
import Home from './Rist/containers/Home'
import Page from './Rist/containers/Page'
import Post from './Rist/containers/Post'
import Tour from './Rist/containers/Tour'
import TourAuslan from './Rist/containers/TourAuslan'
import TourWork from './Rist/containers/TourWork'
import TourMap from './Rist/containers/TourMap'
import NotFound from './Rist/modules/NotFound'


import ReactGA from 'react-ga'
import smoothScroll from './util/smoothScroll'

ReactGA.initialize('UA-25353220-1');


const logPageView = () => {
  ReactGA.set({ page: window.location.pathname});
  ReactGA.pageview(window.location.pathname);
  return null;
}

const updateScroll = () => {
  const hashParts = window.decodeURIComponent(location.hash).split('#')
  if (hashParts.length < 2) {
    smoothScroll.scrollToOffset(0)
  }
  return null;
}



class Routes extends Component {
  render () {
    return (
      <BrowserRouter basename={["www.mca.com.au", "staging.mca.com.au"].includes(window.location.hostname) ? "/pipilotti-rist" : '/'}>
        <div>
          <Route component={logPageView} />
          <Route component={updateScroll} />
          <Switch>
            <Route exact path='/tour/auslan' component={TourAuslan}/>
            <Route exact path='/tour/map' component={TourMap}/>
            <Route exact path='/tour/work/:id' component={TourWork}/>
            <Route exact path='/tour' component={Tour}/>
            <Route path='/' component={Wrapped}/>
          </Switch>
        </div>
      </BrowserRouter>
    )
  }
}

class Wrapped extends Component {
  render () {
    return (
      <Rist>
        <Switch component={Rist}>
          <Route exact path='/' component={Home}/>

          <Route path='/news/:slug' component={Post}/>
          <Route path='/:slug' component={Page}/>
          <Route path='*' component={NotFound}/>
        </Switch>
      </Rist>
    )
  }
}

export default Routes



// WEBPACK FOOTER //
// ./src/routes.js